import { Save, Loader2, Bell, Receipt, FileText, FolderOpen, Headphones } from 'lucide-react';
import { useEmpresaConfig, Empresa } from '../../../../hooks/useEmpresaConfig';

const opcoes = [
  {
    key: 'notificarFatura' as const,
    icon: Receipt,
    titulo: 'Faturas',
    descricao: 'Notifica quando uma nova fatura é disponibilizada no portal.',
  },
  {
    key: 'notificarRelatorio' as const,
    icon: FileText,
    titulo: 'Relatórios',
    descricao: 'Notifica quando um relatório técnico é publicado.',
  },
  {
    key: 'notificarDocumento' as const,
    icon: FolderOpen,
    titulo: 'Documentos',
    descricao: 'Notifica quando um novo documento (NF, boleto, PMOC) é enviado.',
  },
  {
    key: 'notificarTicket' as const,
    icon: Headphones,
    titulo: 'Tickets',
    descricao: 'Notifica sobre mudanças de status relevantes no atendimento.',
  },
];

export function Notificacoes() {
  const { empresa, setEmpresa, isLoading, isSaving, message, saveEmpresa } = useEmpresaConfig();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (empresa) saveEmpresa(empresa);
  };

  const toggle = (key: keyof Empresa) => {
    if (!empresa) return;
    setEmpresa({ ...empresa, [key]: !(empresa[key] !== false) });
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-8 h-8 text-brand animate-spin" />
      </div>
    );
  }

  if (!empresa) return null;

  return (
    <form onSubmit={handleSubmit} className="space-y-6 max-w-3xl">
      {message && (
        <div className={`p-4 rounded-lg ${message.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
          {message.text}
        </div>
      )}

      <div className="bg-card border rounded-lg p-6">
        <h3 className="font-semibold text-foreground border-b pb-2 mb-4 flex items-center gap-2">
          <Bell className="w-5 h-5 text-brand" />
          Notificações do Portal
        </h3>
        <p className="text-sm text-muted-foreground mb-6">
          Escolha quais eventos geram notificações para os clientes no Portal do Cliente.
          As notificações já enviadas não são removidas ao desativar.
        </p>
        <div className="space-y-2">
          {opcoes.map(({ key, icon: Icon, titulo, descricao }) => {
            const ativo = empresa[key] !== false;
            return (
              <div key={key} className="flex items-center justify-between gap-4 p-4 bg-muted/30 rounded-lg">
                <div className="flex items-center gap-3">
                  <span className="p-2 bg-background rounded-lg">
                    <Icon className="w-5 h-5 text-brand" />
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground">{titulo}</p>
                    <p className="text-xs text-muted-foreground">{descricao}</p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => toggle(key)}
                  aria-pressed={ativo}
                  className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${ativo ? 'bg-brand' : 'bg-muted'}`}
                >
                  <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform ${ativo ? 'translate-x-5' : 'translate-x-1'}`}
                  />
                </button>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex justify-end">
        <button type="submit" disabled={isSaving} className="flex items-center gap-2 px-6 py-2 btn btn-primary disabled:opacity-50">
          {isSaving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Salvar Configurações
        </button>
      </div>
    </form>
  );
}
